import { Capacitor } from '@capacitor/core'

/** True inside the Android app (Capacitor shell), false in a browser. */
export function isNativeApp(): boolean {
  return Capacitor.isNativePlatform()
}

/** `android`, `ios` or `web`. */
export function nativePlatform(): string {
  return Capacitor.getPlatform()
}
